import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import styled from 'styled-components'

export const SliderWrapper = styled(Box)`
    overflow-x: scroll;
    scroll-behavior: smooth;
    max-width: 100%;
    position: relative;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`

const SliderButton = styled(Box)`
    position: absolute;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: ${({ theme }) => theme.colors.grayscale_0};
    box-shadow: 0 7px 20px 0 rgba(0, 0, 0, 0.07);
    top: 7px;
    margin: 0;
`

export const SliderNextButton = styled(SliderButton)`
    right: -23px;
`

export const SliderPrevButton = styled(SliderButton)`
    left: -23px;
`

type SeasonTitleTileProps = {
    isActive: boolean
}

export const SeasonTitleTile = styled(Box)<SeasonTitleTileProps>`
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    width: max-content;
    min-width: 145px;
    height: 60px;

    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 4px;
        background: ${({ theme, isActive }) =>
            isActive ? theme.colors.primary_500 : theme.colors.grayscale_0};
    }
`
type SeasonNameProps = {
    isSpecial?: boolean
}

export const SeasonName = styled(Text)<SeasonNameProps>`
    padding-right: ${({ isSpecial }) => (isSpecial ? '12px' : '0')};
    white-space: pre;
`

export const StyledBadge = styled.img`
    position: absolute;
    top: 4px;
    right: 4px;
`
